import { CompanyParametersQuery, ContextKeys, CountryCollectionQuery, CurrencyCollectionQuery } from '@skylab-shared/business';
import { BO, BusinessObjectBase, QueryBus, Weaver } from '@skylab-shared/core';
import { OrderItemModel, OrderModel } from '@skylab-shared/dataModel';
import { OrderDocumentCalculatorBoPart } from './bo-parts/order-document-calculator.bo-part';
import { OrderItemsNumberingBoPart } from './bo-parts/order-items-numbering.bo-part';
import { OrderPaymentsCalculatorBoPart } from './bo-parts/order-payments-calculator.bo-part';
import { OrderRecipientValidationBoPart } from './bo-parts/order-recipient-validation.bo-part';

@BO({ modelType: OrderModel })
export class OrderBO extends BusinessObjectBase<OrderModel> {
    public constructor(
        weaver: Weaver,
        private readonly queryBus: QueryBus
    ) {
        super(weaver);
        this.initBOParts();
        this.registerItemsValidations();
    }

    private initBOParts(): void {
        this.parts.push(...[
            new OrderItemsNumberingBoPart(this.weaver),
            new OrderPaymentsCalculatorBoPart(this.weaver),
            new OrderRecipientValidationBoPart(this.weaver),
            new OrderDocumentCalculatorBoPart(this.weaver, OrderItemModel)
        ]);
    }

    protected override async initializeAsync(): Promise<void> {
        await super.initializeAsync();

        await Promise.resolve([
            this.localContext.preload(CompanyParametersQuery),
            this.localContext.preload(CountryCollectionQuery),
            this.localContext.preload(CurrencyCollectionQuery),
            this.localContext.preload(ContextKeys.systemCurrency),
        ]);
    }

    private registerItemsValidations(): void {
        this.readonlyChecker.addOmitRule([
            [OrderItemModel, 'price_netBeforeDiscount'],
            [OrderItemModel, 'price_netAfterDiscount'],
            [OrderItemModel, 'symbol'],
            [OrderItemModel, 'commission'],
            [OrderItemModel, 'name'],
        ]);

        this.readonly.addRule([
            [OrderItemModel, 'commission'],
            [OrderItemModel, 'symbol'],
            [OrderItemModel, 'price_netBeforeDiscount'],
            [OrderItemModel, 'price_netAfterDiscount'],
        ], () => true);

        this.readonly.addRule(
            [[OrderItemModel, 'productId'], [OrderItemModel, 'name'], [OrderItemModel, 'unitExternalId']],
            [[OrderItemModel, 'name'], [OrderItemModel, 'unitExternalId'],
        ], ctx => !!ctx.source.productId);
    }
}
